import { useState } from "react";
import execute from "@beeldit/core/services/execute";
import {
  showErrorMessage,
  showSuccessMessage,
} from "@beeldit/core/helpers/messagesHelper";

interface RepairMissingSectionsOptions {
  endpoint?: string;
}

function normalizeEndpoint(endpoint: string) {
  return endpoint
    .replace(/^https?:\/\/[^/]+/i, "")
    .replace(/^\/api\/v1\//i, "")
    .replace(/^\//, "");
}

function useRepairMissingSections() {
  const [repairing, setRepairing] = useState(false);

  const repairMissingSections = async (
    pageId: number,
    options: RepairMissingSectionsOptions = {},
    onSuccess: () => void = () => {}
  ) => {
    if (!pageId || repairing) {
      return;
    }

    const endpoint = normalizeEndpoint(
      options.endpoint ?? `pages/${pageId}/repair-missing-sections`
    );

    setRepairing(true);

    try {
      await execute(endpoint, {});
      showSuccessMessage("successfull_action");
      onSuccess();
    } catch (error: any) {
      const sectionsError = error?.response?.data?.errors?.sections;
      const message =
        Array.isArray(sectionsError) && sectionsError.length > 0
          ? sectionsError[0]
          : typeof sectionsError === "string" && sectionsError
          ? sectionsError
          : error?.response?.data?.message || "server_error";

      showErrorMessage(message);
    } finally {
      setRepairing(false);
    }
  };

  return {
    repairing,
    repairMissingSections,
  };
}

export default useRepairMissingSections;